<div class="fleetExportAssets">
  <header class="fleetExportAssetsHeader" (click)="toggleAll()">
    @if (isFleetExport) {
      <pp-checkbox ppType="solid" [ppChecked]="allSelected"></pp-checkbox>
    }

    {{ 'select_items_to_export' | ppTranslate }}
  </header>

  @for (asset of ppExportAssets; track asset; let index = $index) {
    <pp-fleet-export-page-asset-picker
      [ppExportAsset]="asset"
      [ppSelectable]="ppSelectable"
      (ppExportAssetChange)="exportAssetsChange()"
    ></pp-fleet-export-page-asset-picker>
  }
</div>
